import {
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import styles from "../../screens2/Requirement/Requirement.module.css";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { customTextColor } from "../../utils/const";
import { IoIosArrowRoundBack } from "react-icons/io";
const SalesRecruiter = ({
  image,
  date,
  name,
  skill,
  location,
  rate,
  btn1,
  btn2,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const buttonColor = btn2 === "Viewed" ? "#f2f2f2" : "#f2f2f2";
  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5" }}
    >
      <Box>
        {/* <img src={image} alt="" /> */}
        <span>
        <Typography>
            Date: <b>{date}</b>
          </Typography>
          <Typography>
          Candidate: <b>{name}</b>
          </Typography>
          <Typography>
            Job Profile: <b>{skill}</b>
          </Typography>
          <Typography sx={{ margin: "0 !important" }}>
            Expected Rate: <b>{rate}</b>
          </Typography>
        </span>
      </Box>

      <Box sx={{ alignItems: "center", flexDirection: "column" }}>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>
            <b>Resume</b> <PiFileTextLight fontSize="26px" />
          </Typography>
          <Typography sx={{ marginLeft: "15px" }}>
            <b>Documents</b> <PiFilesLight fontSize="26px" />
          </Typography>
        </span>
        <span>
          <button
            onClick={() => handleClickOpen()}
            style={{ backgroundColor: buttonColor, alignSelf: "flex-end" }}
          >
            {btn1}
          </button>
          <button
            onClick={() => navigate("")}
            style={{
              backgroundColor: buttonColor,
              alignSelf: "flex-end",
              marginLeft: "10px",
            }}
          >
            {btn2}
          </button>
        </span>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogContent>
          <Box className={styles.consultant_details}>
            <span>
              <Typography>
                <b>Hi Ashit Kumar </b>
              </Typography>
              <Typography>
                You have responded to Manoj Kumar’s job post.
              </Typography>
              <Typography>Date: 17 May 2024, 10 :30 PM</Typography>
            </span>
            <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
             >
                <Typography sx={{marginRight:'10px'}}>
                  <PiFileTextLight
                    style={{
                      fontSize: "38px",
                      backgroundColor: "#bed7ed",
                      padding: "4px",
                      borderRadius: "3px",
                      color: "#4c68b0",
                    }}
                  />
                </Typography>
              
                  <Typography>
                    <PiFilesLight
                      style={{
                        fontSize: "40px",
                        backgroundColor: "#bed7ed",
                        padding: "4px",
                        borderRadius: "3px",
                        color: "#4c68b0",
                      }}
                    />
                  </Typography>
                </span>
             
                </Box>
        

          <Grid
            container
            className={styles.profile_details_view}
            sx={{ color: customTextColor }}
          >
            <Grid
              item
              md={6}
              lg={6}
              sx={{ display: "block !important" }}
              className={styles.profile_details_views}
            >
              <ul style={{ listStyleType: "square", padding: "20px" }}>
                <Box>
                  <li>
                    <Typography>
                    Candidate Name:  <b> Ramesh Kumar Reddy </b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                    Phone No: 
                      <b>242-750-2230</b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                    Work Authorization: 
                      <b>GC EAD</b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                    Location: 
                      <b>Chicago Illinois, CH </b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                    Candidate familiar to Job description: 
                      <b>Yes</b>
                    </Typography>
                  </li>
                </Box>
                <Box sx={{ marginBottom: "0 !important" }}>
                  <li>
                    <Typography>
                    Candidate Authorized to discuss about Rate:
                      <b> Yes</b>
                    </Typography>
                  </li>
                </Box>
              </ul>
            </Grid>

            <Grid
              item
              md={6}
              lg={6}
              sx={{ display: "block !important", position:'relative', bottom:'15px' }}
              className={styles.profile_details_views}
            >
              <ul style={{ listStyleType: "square" }}>
                <Box>
                  <li>
                    <Typography>
                    Job Profile:  <b>Java Developer</b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                      Experience:<b> 10 Years </b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      E-Mail ID: <b> rameshkumarreddy17@gmail.com </b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                    Willing to Relocate:  <b>Yes</b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                    Billing: 
                      <b>$70 Hourly (Negotiate)</b>
                    </Typography>
                  </li>
                </Box>
              </ul>
            </Grid>
          </Grid>

          <Box className={styles.send_update_btns}>
            <Box className={styles.back_btns}>
              <button
                onClick={() => navigate("/job-post-list-view")}
                style={{
                  border: "1.5px solid #4285f4",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                  backgroundColor: "#f0f2f5",
                }}
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#4285f4" }}
                />
              </button>
            </Box>

            <Box className={styles.action_update_btns}>
              <button style={{ backgroundColor: "#3856a6" }}>Hide</button>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </Box>
  );
};

export default SalesRecruiter;
